import { createContext } from "react";

import { DateTime } from "luxon";

import AddressInput from "api/types/AddressInput";
import BusinessOrderType from "api/types/BusinessOrderType";
import MenuGroup from "api/types/MenuGroup";
import MenuItem from "api/types/MenuItem";

export interface CustomerInformation {
	fullName: string | undefined;
	deliveryAddress: AddressInput | null;
	phoneNumber: string | undefined;
	email: string | undefined;
}

interface CartItem {
	localId: string;
	menuItem: MenuItem;
	specialInstructions: string;
	quantity: number;
	selectedOptions: {
		menuItemOptionId: string;
		menuItemOptionGroupId?: string;
		priceCents?: number;
		displayPrice?: string;
		preparationTimeMinutes?: number;
	}[];
	unitPriceCents: number;
	extendedPriceCents: number;
}

interface Cart {
	isConfirmationVisible: boolean;
	orderId?: string;

	cartItemsCount: number;
	cartItems: CartItem[];

	cartItemByLocalId: {
		[localId: string]: CartItem;
	};

	cartTotalCents: number;
	taxCents: number | null;
	tipCents: number | null;
	tipPercentage: number | null;
	discount: number | null;
	percentOff: number | null;
	promoCode: string | null;
	grandTotalCents: number | null;

	orderType: Partial<BusinessOrderType> | null;
	deliveryOrPickupAt?: DateTime;
	preparationTimeMinutes: number;

	fullName: string | undefined;
	deliveryAddress: AddressInput | null;
	phoneNumber: string | undefined;
	email: string | undefined;
	paymentInfo: null | Record<string, any>;
}

interface Methods {
	setState(state: Cart | ((prevState: Cart) => Cart)): void;

	getDeliveryOrPickupIntervals(): {
		date: string;
		intervals: {
			startsAt: DateTime;
			endsAt: DateTime;
		}[];
	}[];

	/**
	 * Selected deliveryOrPickupAt or null if not selected or invalid / less than now
	 */
	getEffectiveDeliveryOrPickupAt(): undefined | DateTime;

	getDisplayDeliveryOrPickupAt(): undefined | DateTime;

	areAllItemsAvailable(): boolean;

	isItemAvailable(
		menuItem?: undefined | null | { menuGroup?: undefined | null | Pick<MenuGroup, "availability"> }
	): boolean;
}

const CartContext = createContext<Cart & Methods>({} as any);

export default CartContext;
